<header>
  <nav>
    <a class="logo" routerLink="/">
      <strong>Where in the world?</strong>
    </a>
  </nav>
  <nav>
    <div class="theme-button">

      <button class="toggle" (click)="switchTheme()">
        {{ theme === "light-theme" ? "🌙  Dark Mode" : "🌞  Light Mode" }}
      </button>

      

    </div>
  </nav>
</header>